import React from "react";
import { Button,Modal, Row, Col,Container  } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
export default function TalentProfileModal(props) {
  console.log(props.talent)
    return (
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
          {props.talent.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Container>
            <Row>
              <Col xs={12} md={8}>
               <div >
                <Button>Connect</Button>
               </div>
              </Col>
            </Row>
            <Row>
              <Col xs={8} md={6}>
              <div>
          {props.talent.skills.map((skill, index) => (
            <div key={index}>
              <p>{skill}</p>
            </div>
          ))}
        </div>
              </Col>
              <Col xs={4} md={6}>
                <h1>Experience</h1>
                <h5>Education</h5>
          <p>{props.talent.education}</p>
              </Col>
            </Row>
            <Row>
              <Col xs={6} md={4}>
              </Col>
              <Col xs={6} md={4}>
              </Col>
              <Col xs={6} md={4}>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }